<template>
  <v-container fluid class="pa-3">
    <div class="plantillas-vista__escuela mb-3">
      <span class="plantillas-vista__label mr-2">Escuela</span>
      <v-btn
        small
        depressed
        :color="escuela === 1 ? '#00A548' : undefined"
        :dark="escuela === 1"
        :outlined="escuela !== 1"
        class="mr-1"
        @click="escuela = 1"
      >INBI</v-btn>
      <v-btn
        small
        depressed
        :color="escuela === 2 ? '#00A548' : undefined"
        :dark="escuela === 2"
        :outlined="escuela !== 2"
        @click="escuela = 2"
      >FAST</v-btn>
    </div>
    <PlantillasCatalogo :key="'escuela-' + escuela" :escuela="escuela" standalone />
  </v-container>
</template>

<script>
  import PlantillasCatalogo from '@/components/whatsapp/PlantillasCatalogo.vue'

  export default {
    name: 'PlantillasWhatsApp',

    components: { PlantillasCatalogo },

    data: () => ({
      escuela: 1,
    }),
  }
</script>

<style scoped>
  .plantillas-vista__escuela {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .plantillas-vista__label {
    font-size: 13px;
    font-weight: 600;
    color: #3b4a54;
  }
</style>
